const submitQuizResponse = async (payload: unknown) => {
    const apiResponse = await fetch('https://service.tangent.ai/shopify/responses', {
        method: "post",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
    })
    return await apiResponse.json();
};

export default submitQuizResponse;